import { Box, Button, HStack, SubmitButton } from '@medely/ui-kit';
import React from 'react';

type ApplicationButtonsProps = {
  disabled: boolean;
  backClick: () => void;
  loading?: boolean;
  onContinueClick?: () => void;
};

export const ApplicationButtons = ({
  disabled,
  backClick,
  loading,
  onContinueClick,
}: ApplicationButtonsProps) => {
  return (
    <HStack gap={2}>
      <Box width="48%">
        <Button
          disabled={disabled}
          onClick={backClick}
          loading={loading}
          testId="application-back-button"
          variant="outlined"
          fullWidth
        >
          Back
        </Button>
      </Box>

      <Box width="48%">
        <SubmitButton
          disabled={disabled}
          loading={loading}
          {...(onContinueClick ? { onClick: onContinueClick } : {})}
          testId="application-continue-button"
          fullWidth
        >
          Continue
        </SubmitButton>
      </Box>
    </HStack>
  );
};
